import { Component, HostBinding, Input, ViewChild } from '@angular/core';
import { EventItem } from '../../../interfaces/event';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { LocationSelectPickerComponent } from '../../location-select-picker/location-select-picker.component';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';

@Component({
  selector: 'app-month-event-item',
  templateUrl: './month-event-item.component.html',
  styleUrls: ['./month-event-item.component.scss']
})
export class MonthEventItemComponent {
  @Input() event!: EventItem;
  @HostBinding('class.skeleton') @Input() isLoading?: boolean;
  @Input() studentCalendarFilters: any;
  @Input() notificationHeader: string = '';
  @Input() submissionLabel: string = '';
  @Input() atHourLabel: string = '';

  @ViewChild('locatinPicker') locatinPicker!: LocationSelectPickerComponent;

  openedNotifications: boolean = false;

  @HostBinding('style.--type-color') get type() {
    if(this.isLoading) return "";

    return FiltersColorHelper.getPrimaryColor(this.event.type as number, this.studentCalendarFilters);
  };

  StudentDataType = StudentDataType;

  openNotificationClick(event: any) {
    event.preventDefault();
    this.openedNotifications = true;
  }

  closeNotifications() {
    this.openedNotifications = false;
  }

  showEndTime(): boolean {
    return this.event.startTime != this.event.endTime;
  }
}
